import { JSX, useContext, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { SpaClientOnlyHeaderContext } from '@chewy/header-footer-react/dist/components/react/src/header/spa/spa-header.context';
import { SpaHeader } from '@chewy/header-footer-react/dist/components/react/src/header/spa/spa-header';
import getSpaComponentProps, {
  SpaComponentPropsError,
  SpaComponentPropsResponse,
} from '@chewy/header-footer-react/dist/common/spa/spa.util';

import { useDynatrace } from '@src/hooks/use-dynatrace.hook';
import { ServerConfigContext } from '@src/contexts/server-config-context';
import {
  getHeaderEnvironment,
  getHeaderEnvironmentUrl,
} from '@src/helpers/header-footer.helper';
import { getUserAgent } from '@src/helpers/user-agent.helper';

const UnsafeChewyHeader = (): JSX.Element => {
  const [spaComponentProps, setSpaComponentProps] = useState<
    SpaComponentPropsResponse | SpaComponentPropsError | null
  >(null);

  const { headerEnv } = useContext(ServerConfigContext);

  const env = getHeaderEnvironment(headerEnv);

  useEffect(() => {
    let mounted = true;

    void (async () => {
      const props = await getSpaComponentProps({
        componentType: 'header',
        baseURL: getHeaderEnvironmentUrl(env),
        csr: true,
        pageType: 'pet_insurance',
        serviceName: 'pet_insurance',
      });

      if (mounted) {
        setSpaComponentProps(props);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      <div id="header" />
      {spaComponentProps && (
        <SpaClientOnlyHeaderContext.Provider
          value={{
            pageType: 'pet_insurance',
            env: env,
            mountElemId: 'header',
          }}
        >
          <SpaHeader {...(spaComponentProps as SpaComponentPropsResponse)} />
        </SpaClientOnlyHeaderContext.Provider>
      )}
    </>
  );
};

export const ChewyHeader = () => {
  const { reportError } = useDynatrace();
  const { isNma } = getUserAgent();
  if (isNma) return null;

  return (
    <ErrorBoundary
      FallbackComponent={() => <></>}
      onError={(error) => {
        reportError(error);
      }}
    >
      <UnsafeChewyHeader />
    </ErrorBoundary>
  );
};
